/** Maps API `moduleName` values (including DB aliases) to top-level app route segments. */
export const MODULE_NAME_TO_ROUTE: Record<string, string> = {
  Shipment: 'hawb',
  Bag: 'bag',
  Manifest: 'manifest',
  MAWB: 'mawb',
  'Accounts Payable': 'accounts-payable',
  'Account Payable': 'accounts-payable',
  'Accounts Receivable': 'accounts-receivable',
  'Account Receivable': 'accounts-receivable',
  'Setup & Maintenance': 'sm-dashboard',
  'Setup and Maintenance': 'sm-dashboard',
  Dashboard: 'dashboard',
  Reports: 'reports',
};

/** API Dashboard actionName → runtime dashboard type code (case-insensitive key). */
export const DASHBOARD_ACTION_NAME_TO_CODE: Record<string, string> = {
  'customer service': 'customer-service',
  operations: 'operations',
  warehouse: 'warehouse',
  'data entry': 'data-entry',
  brokerage: 'brokerage',
  'accounts payable': 'ap',
  'accounts receivable': 'ar',
};

export function resolveDashboardCodeFromActionName(
  actionName: string
): string | undefined {
  return DASHBOARD_ACTION_NAME_TO_CODE[actionName.trim().toLowerCase()];
}

/** Normalize R&P report actionName / runtime reportName for case-insensitive match. */
export function normalizeReportPermissionKey(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/\s+/g, ' ');
}

export function reportActionNameMatchesReportName(
  actionName: string,
  reportName: string
): boolean {
  return (
    normalizeReportPermissionKey(actionName) ===
    normalizeReportPermissionKey(reportName)
  );
}

export function isReportTypePermittedByActionNames(
  permittedActionNames: string[],
  reportName: string
): boolean {
  if (!permittedActionNames.length) {
    return false;
  }
  return permittedActionNames.some((actionName) =>
    reportActionNameMatchesReportName(actionName, reportName)
  );
}

export const ENFORCED_PERMISSION_ROUTES = new Set(
  Object.values(MODULE_NAME_TO_ROUTE)
);

/** Sidebar order — used to pick redirect target after access denied. */
export const PERMITTED_ROUTE_PRIORITY: readonly string[] = [
  'dashboard',
  'hawb',
  'bag',
  'manifest',
  'mawb',
  'accounts-payable',
  'accounts-receivable',
  'sm-dashboard',
  'reports',
];

/** Always reachable; sole sidebar item while permissions load; fallback when no module access. */
export const HOME_ROUTE = 'home';

/** Access-denied / no-module fallback (FR-011) — always-visible sidebar home route. */
export const PERMISSIONS_FALLBACK_ROUTE = HOME_ROUTE;

/** Max wait for profile + permissions bootstrap before FR-012-style empty resolve (F-006). */
export const PERMISSIONS_BOOTSTRAP_TIMEOUT_MS = 30_000;

export function resolveModuleRoute(moduleName: string): string | undefined {
  return MODULE_NAME_TO_ROUTE[moduleName];
}
